import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import Footer from './global-components/footer';
import CartPage from './section-components/CartPage';

const CartPagem = () => {
    return <div>
        <Navbar />
        <PageHeader headertitle="Your Cart"  />
        <CartPage/>
        <Footer />
    </div>
}

export default CartPagem

